import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useIdentificationChartsDataContext } from './hooks/useIdentificationChartsDataContext';

export const Apgar1Minute = () => {
    const { chartData } = useIdentificationChartsDataContext();


    return (
        <SimpleBars
            title={'Indice de Apgar 1 minutos'}
            horizontal={false}
            subtitles={chartData?.apgar1Minute?.map((item) => item.description)}
            values={chartData?.apgar1Minute?.map((item) => item.total  ||  0)}
        />
    );
};
